import React, { useEffect, useMemo, useRef, useState } from "react";

import { FiltersProps } from "./Filters.model";
import { JPInputFilter } from "../Inputs/JPInputFilter";
import { JPInputSearch } from "../Inputs/JPInputSearch";
import { useMediaQuery } from "@companion-core/web/src/Utilities/mediaQuery";
import { useHeaderScroll } from "@companion-core/web/src/Hooks/headerScroll";
import { useFiltersStore } from "@companion-core/shared/app/Store/filters";
import { formatFilters } from "@companion-core/shared/app/Utils/filters";
import { trackClickSearchFilter } from "@companion-core/shared/app/tracking/filters";

import "@companion-core/web/src/Assets/Styles/scss/filters.scss";

export const Filters = ({
  testID,
  filters,
  withSearchBar = false,
  withGeolocalisation = false,
}: FiltersProps) => {
  const isMobileSize = useMediaQuery("(max-width: 768px)");
  const [isFocused, setIsFocused] = useState(false);
  const { isHeaderVisible } = useHeaderScroll();
  const { filters: savedFilters, search, setFilters, setSearch } = useFiltersStore();
  const ref = useRef<{ resetInput: () => void } | null>(null);
  const displayFilters = useMemo(() => filters && filters.length > 0, [filters]);

  useEffect(() => {
    if (ref && displayFilters && !savedFilters) ref.current?.resetInput();
  }, [savedFilters]);

  const displayBothElement = useMemo(
    () => withSearchBar && displayFilters,
    [withSearchBar, displayFilters]
  );
  return (
    <div className={`filters ${isHeaderVisible ? "" : "filters--no-header"}`} data-testid={testID}>
      <div
        className={`filters__container ${displayBothElement ? "filters__display-two-elements" : "filters__display-one-element"}`}>
        {displayFilters && !isFocused && (
          <>
            <JPInputFilter
              ref={ref}
              size="medium"
              filters={filters ?? []}
              withGeolocalisation={withGeolocalisation}
              testID={testID}
              className="filters__filter"
              onValueChange={(values) => {
                const formattedFilters = formatFilters(values);
                const nextFilters = { ...formattedFilters };
                const persisted = useFiltersStore.getState().filters;
                if (persisted?.geo_place_id) {
                  nextFilters.geo_place_id = persisted.geo_place_id;
                }
                if (persisted?.geo_place_level) {
                  nextFilters.geo_place_level = persisted.geo_place_level;
                }
                setFilters(nextFilters);
              }}
            />
          </>
        )}
        {withSearchBar && (
          <JPInputSearch
            testID={testID}
            value={search}
            onFocus={() => isMobileSize && setIsFocused(true)}
            onBlur={() => isMobileSize && setIsFocused(false)}
            onSubmit={(value) => {
              trackClickSearchFilter(value);
              setSearch(value);
            }}
          />
        )}
      </div>
    </div>
  );
};
